import { START_LISTENING_FOR_STATS } from "./actionTypes";
export function startListeningForStats(conference) {
    return {
        type: START_LISTENING_FOR_STATS,
        conference
    };
}
